<template>
  <nav aria-label="breadcrumb" class="breadcrumb-area">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
      <li class="breadcrumb-item active" aria-current="page">通年プログラム予約前確認事項</li>
    </ol>
  </nav>
  <div class="container">
      <div class="top--section">
        <Confirmation/>
      </div>
  </div>
</template>
<script setup lang="ts">
import Confirmation from '@/components/Static/AnnualConfirmation.vue'
</script>